import { AdminPageHeader } from '@/components/patterns/admin-page'
import DesignForm from '@/components/forms/DesignForm/DesignForm'
import { categoryQueries } from '@/lib/services/categories/categories.query'
import {
  collectionQueries,
  designCollectionsFilters,
} from '@/lib/services/collections/collections.query'
import { designQueries } from '@/lib/services/designs/designs.query'
import { designProductsFilters, productQueries } from '@/lib/services/products/products.query'
import { storeQueries } from '@/lib/services/stores/stores.query'
import { createFileRoute, notFound } from '@tanstack/react-router'
import { Wallpaper } from 'lucide-react'

export const Route = createFileRoute('/_authenticated/$orgId/designs/create')({
  component: DesignCreatePage,
  loader: async ({ context, params }) => {
    if (!context.ability.can('create', 'designs')) throw notFound()
    if (Number(params.orgId) === Number(import.meta.env.VITE_TUKIOS_FLOWERS_ORG_ID))
      throw notFound()

    const defaultDesignTemplate = await context.queryClient.ensureQueryData(
      designQueries.default({ organizationId: params.orgId })
    )
    await Promise.all([
      context.queryClient.ensureQueryData(storeQueries.themes({ organizationId: params.orgId })),
      context.queryClient.ensureQueryData(
        collectionQueries.index({
          organizationId: params.orgId,
          filters: designCollectionsFilters,
        })
      ),
      context.queryClient.ensureQueryData(
        productQueries.index({
          organizationId: params.orgId,
          filters: designProductsFilters,
        })
      ),
      context.queryClient.ensureQueryData(categoryQueries.index({ organizationId: params.orgId })),
    ])

    return { isReadOnly: false, defaultDesignTemplate }
  },
})

export function DesignCreatePage() {
  const { defaultDesignTemplate } = Route.useLoaderData()

  return (
    <div className="max-w-none space-y-4">
      <AdminPageHeader
        icon={Wallpaper}
        title="Create Seasonal Website Update"
        description="Build a temporary update for holidays, occasions, or promotions."
      />
      <DesignForm
        templateData={defaultDesignTemplate}
        defaultDesign={defaultDesignTemplate}
        presentation="seasonal-workspace"
      />
    </div>
  )
}
